import { DEFAULT_LIMIT_ITEMS } from "constants/data";
import { useEffect, useMemo, useState } from "react";
import { ChangelogType, PaginationParamType } from "type";
import getChangelogApi from "../api/changelogApi";

/**
 * Hook for page changelog
 */
export default function useChangelog() {
  const [changelog, setChangelog] = useState<ChangelogType[]>([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const totalPage = useMemo(() => Math.ceil(total / DEFAULT_LIMIT_ITEMS), [total]);

  const getChangelog = async (body?: PaginationParamType) => {
    try {
      const data = await getChangelogApi(body);
      if (body && body?.offset > 1) {
        setChangelog((prev) => [...prev, ...data.list]);
      } else {
        setChangelog(data.list);
      }
      setTotal(data.total);
    } catch (error) {
      // do nothing
    }
    setLoading(false);
  };

  useEffect(() => {
    getChangelog();
  }, []);

  const onLoadMore = async () => {
    if (page + 1 > totalPage) return;
    setLoading(true);
    setPage((prevPage) => prevPage + 1);
    await getChangelog({ offset: page + 1 });
  };

  return { changelog, total, totalPage, page, loading, onLoadMore };
}
